<template>
    <div class="c-container" v-bind:class="[{'c-container--large':large}]">
        <slot></slot>
        <div class="c-container__positioned">
            <slot name="positioned"></slot>
        </div>
    </div>
</template>
<script>
export default {
    props:['large']
}
</script>
<style lang="scss">
    .c-container{
        max-width: 1430px;
        padding: 2rem 1rem;
        margin: 0 auto;
        &--large{
            padding: 6rem 1rem;
        }
        @media(min-width: 960px){
            &__positioned{
                margin-left: 10vw;
            }
        }
        @media (max-width:1430px) {
            max-width: 1124px;
        }
    }
</style>